module.exports = __webpack_public_path__ + "img/ffflogo.46eb7eb8.png";